import { Box, Card, Container, Grid, Typography } from '@mui/material';
import rpa from '../../assets/rpa.png';
import './index.css';
import { useEffect } from 'react';

const ServiceTech = ({ values }) => {

    return (
        <Container maxWidth={false} style={{ padding: "0px" }}>
            <Card
                style={{
                    backgroundColor: "#0B77A8",
                    borderRadius: "20px",
                    padding: "22px",
                    margin: "20px",
                    position: "relative",
                    overflow: "hidden",
                    height: "100%" // Ensures images are clipped within the card
                }}
            >
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={7} md={8} lg={7} xl={5}>
                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: {
                                    xs: "1.5rem",
                                    sm: "1.8rem",
                                    md: "2.0rem",
                                    lg: "2.5rem",
                                    xl: "2.1rem",
                                },
                                lineHeight: {
                                    xs: "1.8rem",
                                    sm: "1.8rem",
                                    md: "unset",
                                    lg: "inherit",
                                    xl: "2",
                                },
                                color: "white",
                            }}
                            className='poppins-semibold'
                        >
                            {values.maintitle}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={5} md={4} lg={5} xl={7}>
                        {/* Image Container */}
                        <Box
                            sx={{
                                width: {
                                    xl: "40%",
                                }, // Full width of the grid item
                                height: "100%", // Full height of the grid item
                                overflow: "hidden", // Ensures the image doesn't spill out of the container
                                display: "flex",
                                margin: "auto", // Centers the image horizontally if necessary
                            }}
                        >
                            <Box
                                component="img"
                                src={values.headerimg}
                                alt="Sliding Image"
                                sx={{
                                    width: "100%", // Image should take up full width of the container
                                    height: "100%", // Image should take up full height of the container
                                    objectFit: "cover",
                                    borderRadius: "20px" // Ensures the image covers the container without distortion
                                }}
                            />
                        </Box>
                    </Grid>


                    <Grid item xs={12}>
                        <Box
                            sx={{
                                backgroundColor: "white",
                                height: "2px",
                                width: "90%",
                                margin: "10px auto",
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="h6" color="white" className='poppins-semibold'>
                            {values.mainsub}
                        </Typography>
                    </Grid>
                </Grid>
            </Card>

            <Grid container spacing={5} style={{ padding: "50px 0px 50px 0px" }}>
                <Grid
                    item
                    xs={12}

                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingTop: "70px"
                    }}
                >
                    <Typography variant='h4' style={{ color: "#1166A6",textAlign:"center" }} className='poppins-semibold'>
                        {values.title}
                    </Typography>
                </Grid>

                {/* Paragraph section */}
                <Grid item xs={12} style={{ textAlign: "center",padding:"15px" }}>
                    <Typography
                        component='p'
                        className='poppins-regular'
                        sx={{
                            fontSize: {
                                xl: "1.5rem",
                                lg: "1.5rem",
                                xs: "0.7rem",
                                sm: "1.2rem",
                                md: "0.7rem"
                            },
                            color: "black",
                            flex: 1,
                            textAlign: 'center',
                            margin: '0',
                            marginLeft: "30px"
                        }}
                    >
                        {values.subtext}
                    </Typography>
                </Grid>
            </Grid>
            <Box
                sx={{
                    padding: "50px 0",
                    margin: "0 30px",
                    borderRadius: "70px",
                    backgroundColor: "#F4F7FC",
                }}
            >
                <Grid container spacing={8} justifyContent="center">
                    {/* Image and Text Block 1 */}
                    <Grid item xs={12} sm={6} md={4} textAlign="center">
                        <Box>
                            <Box
                                component="img"
                                src={values?.key1img} // Replace with your actual image source
                                alt="Image 1"
                                sx={{
                                    width: "264px", // Full width on smaller screens
                                    height: '240px',
                                    maxWidth: "315px", // Limit max width for larger screens
                                    objectFit: "cover",
                                    borderRadius: "15px",
                                }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    mt: 2,
                                    fontSize: {
                                        xl: "1rem",
                                        lg: "1rem",
                                        md: "0.8rem",
                                        sm: "0.8rem",
                                        xs: "0.8rem",
                                    },
                                    padding:"10px",
                                    lineHeight: "normal",
                                    textAlign: "center"
                                }}
                                className="poppins-regular"
                            >
                                {values.choose1} {/* Replace with your text */}
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Image and Text Block 2 */}
                    <Grid item xs={12} sm={6} md={4} textAlign="center">
                        <Box>
                            <Box
                                component="img"
                                src={values?.key2img} // Replace with your actual image source
                                alt="Image 2"
                                sx={{
                                    width: "264px", // Full width on smaller screens
                                    height: '240px',
                                    maxWidth: "315px", // Limit max width for larger screens
                                    objectFit: "cover",
                                    borderRadius: "15px",
                                }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    mt: 2,
                                    fontSize: {
                                        xl: "1rem",
                                        lg: "1rem",
                                        md: "0.8rem",
                                        sm: "0.8rem",
                                        xs: "0.8rem",
                                    },
                                    padding:"10px",
                                    lineHeight: "normal",
                                    textAlign: "center"
                                }}
                                className="poppins-regular"
                            >
                                {values.choose2} {/* Replace with your text */}
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Image and Text Block 3 */}
                    <Grid item xs={12} sm={6} md={4} textAlign="center">
                        <Box>
                            <Box
                                component="img"
                                src={values?.key3img} // Replace with your actual image source
                                alt="Image 3"
                                sx={{
                                    width: "264px", // Full width on smaller screens
                                    height: '240px',
                                    maxWidth: "315px", // Limit max width for larger screens
                                    objectFit: "cover",
                                    borderRadius: "15px",
                                }}
                            />
                            <Typography
                                variant="h6"
                                sx={{
                                    mt: 2,
                                    fontSize: {
                                        xl: "1rem",
                                        lg: "1rem",
                                        md: "0.8rem",
                                        sm: "0.8rem",
                                        xs: "0.8rem",
                                    },
                                    padding:"10px",
                                    lineHeight: "normal",
                                    textAlign: "center"
                                }}
                                className="poppins-regular"
                            >
                                {values.choose3} {/* Replace with your text */}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box sx={{ padding: "50px 70px 50px 70px" }}>
                <Typography variant="div" sx={{ display: "flex", marginBottom: "20px" }} className='poppins-bold'>
                    <Typography variant='h4' style={{ color: "black", marginRight: "5px" }} className='poppins-semibold'>
                        KEY
                    </Typography>
                    <Typography variant='h4' style={{ color: "#1166A6" }} className='poppins-semibold'>
                        FOCUS AREA
                    </Typography>
                </Typography>
                <Grid container spacing={4}>
                    {/* Column 1 */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} className='poppins-semibold'>
                            {values.key1}
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px" }} className='poppins-regular'>
                            {values.text1}
                        </Typography>
                    </Grid>

                    {/* Column 2 */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} className='poppins-semibold'>
                            {values.key2}
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px" }} className='poppins-regular'>
                            {values.text2}
                        </Typography>
                    </Grid>

                    {/* Column 3 */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} className='poppins-semibold'>
                            {values.key3}
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px" }} className='poppins-regular'>
                            {values.text3}
                        </Typography>
                    </Grid>

                    {/* Column 4 */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} className='poppins-semibold'>
                            {values.key4}
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px" }} className='poppins-regular'>
                            {values.text4}
                        </Typography>
                    </Grid>

                    {/* Column 5 */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} className='poppins-semibold'>
                            {values.key5}
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px" }} className='poppins-regular'>
                            {values.text5}
                        </Typography>
                    </Grid>

                    {/* Column 6 */}
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} className='poppins-semibold'>
                            <Typography component='span' variant="h5" className='poppins-semibold' sx={{
                                color: "#00A3E0"
                            }}>Edgology </Typography>
                            Think
                        </Typography>
                        <Typography variant="body1" sx={{ marginTop: "10px" }} className='poppins-regular'>
                            {values.text6}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}

export default ServiceTech;
